export default __webpack_public_path__ + "static/media/s_wdt_c_5.1db3b358.mp3";